<template>
  <div>
    <!-- Başlık -->
    <v-toolbar flat color="info" dark>
      <v-toolbar-title>{{ $t('Log-Records') }}</v-toolbar-title>
    </v-toolbar>

    <!-- Tarih + Butonlar -->
    <v-card flat color="grey lighten-5">
      <v-container fluid>
        <v-layout row wrap align-center>
          <!-- Başlangıç Tarihi -->
          <v-flex xs12 sm4 md2>
            <tarihim
              :etiket="$t('Starting-Date')"
              v-model="date"
              :detaygizle="false"
              :defaultvalue="'ok'"
              :rules="[v => !!v || $t('Please-select-a-date')]"
            />
          </v-flex>

          <!-- Bitiş Tarihi -->
          <v-flex xs12 sm4 md2>
            <tarihim
              :etiket="$t('Finishing-Date')"
              v-model="date2"
              :detaygizle="false"
              :defaultvalue="'ok'"
              :rules="[v => !!v || $t('Please-select-a-date')]"
            />
          </v-flex>

          <!-- Butonlar (Arama + Filtre + Seçili Tip Chip) -->
          <v-flex xs12 sm4 md4>
            <v-btn color="info" fab small dark class="mr-2" @click="getir">
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn color="info" fab small dark class="mr-3" @click="dialogfiltre = true">
              <v-icon>filter_list</v-icon>
            </v-btn>

            <v-chip small class="mt-2 mt-sm-0" color="info" text-color="white">
              <v-icon left small>label</v-icon>
              {{ selectedFilterLabel }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <!-- Tablo -->
    <v-card flat>
      <v-data-table
        :headers="tableHeaders"
        :items="items"
        :loading="loading"
        class="elevation-1"
        :rows-per-page-items="[25,10,50,100]"
        :pagination.sync="pagination"
        :no-data-text="noDataText"
        :rows-per-page-text="$t('Rows-Per-Page')"
      >
        
        <v-progress-linear slot="progress" indeterminate height="3"></v-progress-linear>

        
        <template slot="no-data">
          <div class="pa-4 text-xs-center">
            <v-progress-circular indeterminate class="mr-2" v-if="loading"></v-progress-circular>
            <span>{{ noDataText }}</span>
          </div>
        </template>

        
        <template slot="items" slot-scope="props">
          <tr>
            <!-- CARI -->
            <template v-if="selectedFilter === 'cari'">
              <td>{{ props.item.EvrakNo }}</td>
              <td class="text-xs-right">{{ num(props.item.Tutar) }}</td>
              <td>{{ dt(props.item.KayitTar) }}</td>
              <td>{{ props.item.KayitEden }}</td>
              <td>{{ props.item.PosKod }}</td>
              <td>{{ props.item.KarsiCari }}</td>
            </template>

            <!-- BILET -->
            <template v-else-if="selectedFilter === 'bilet'">
              <td>{{ props.item.YolcuAdi }}</td>
              <td>{{ props.item.BiletNo }}</td>
              <td>{{ props.item.PnrNo }}</td>
              <td>{{ dt(props.item.SatisTarihi) }}</td>
              <td class="text-xs-right">{{ num(props.item.Tutar) }}</td>
              <td>{{ props.item.HavaYolu }}</td>
              <td>{{ props.item.IslemYapan }}</td>
              <td>{{ dt(props.item.HistoryDate) }}</td>
              <td>{{ props.item.HistoryTime }}</td>
              <td>{{ props.item.HistoryComputer }}</td>
            </template>

            <!-- COPER -->
            <template v-else>
              <td>{{ dt(props.item.Tarih) }}</td>
              <td>{{ props.item.Kullanici }}</td>
              <td>{{ props.item.Islem }}</td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Filtre Popup -->
    <v-dialog v-model="dialogfiltre" max-width="400">
      <v-card class="pa-4">
        <v-card-title class="headline justify-center">{{ $t('Filter-selection') }}</v-card-title>

        <v-card-text class="text-center">
          <div class="font-weight-medium mb-2">{{ $t('Log-Type') }}</div>
          <v-radio-group v-model="selectedFilter" class="d-inline-block text-left">
            <v-radio :label="$t('Current-Actions')" value="cari"></v-radio>
            <v-radio :label="$t('Ticket')" value="bilet"></v-radio>
            <v-radio label="Coper" value="coper"></v-radio>
          </v-radio-group>

          
          
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn flat @click="dialogfiltre = false">{{ $t('Cancel') }}</v-btn>
          <v-btn color="primary" flat @click="filtreyiUygula">{{ $t('Apply') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tarihim from '../customcomp/tarihim'
import auth from '../../../api/auth'

export default {
  components: { tarihim },
  data () {
    const today = new Date()
    return {
      date: today,
      date2: today,
      dialogfiltre: false,
      selectedFilter: 'cari',
      excludeListMethods: true, // Coper'da "List" içerenleri gizle
      loading: false,
      error: null,
      items: [],
      tableHeaders: [],
      pagination: { rowsPerPage: 25 }, // varsayılan 25
      endpointMap: {
        cari:  'api/CurrentMovement/GetCariIptalKayitlari',
        bilet: 'api/Ticket/GetHistoryBiletKayitlariView',
        coper: 'api/Coper/GetCoperLogs'
      },
      headersMap: {
        cari: [
          { text: this.$t('Document-No'), value: 'EvrakNo' },
          { text: this.$t('Amount'), value: 'Tutar', align: 'right' },
          { text: this.$t('Registration-Date'), value: 'KayitTar' },
          { text: this.$t('Registered-By'), value: 'KayitEden' },
          { text: 'Pos', value: 'PosKod' },
          { text: this.$t('Counter-Current'), value: 'KarsiCari' }
        ],
        bilet: [
          { text: this.$t('Name-of-Passenger'), value: 'YolcuAdi' },
          { text: this.$t('Ticket-No'), value: 'BiletNo' },
          { text: 'PNR', value: 'PnrNo' },
          { text: this.$t('Sales-Date'), value: 'SatisTarihi' },
          { text: this.$t('Amount'), value: 'Tutar', align: 'right' },
          { text: this.$t('Airline'), value: 'HavaYolu' },
          { text: this.$t('Processed-By'), value: 'IslemYapan' },
          { text: 'HistoryDate', value: 'HistoryDate' },
          { text: 'HistoryTime', value: 'HistoryTime' },
          { text: 'PC', value: 'HistoryComputer' }
        ],
        coper: [
          { text: this.$t('Date'), value: 'Tarih' },
          { text: this.$t('User'), value: 'Kullanici' },
          { text: this.$t('Process'), value: 'Islem' }
        ]
      }
    }
  },
  computed: {
    noDataText () {
      if (this.loading) return this.$t('Loading') + '...'
      if (this.error)   return this.error
      return this.$t('No-Records-Found')
    },
    selectedFilterLabel () {
      return this.selectedFilter === 'cari'
        ? this.$t('Current')
        : this.selectedFilter === 'bilet'
          ? this.$t('Ticket')
          : 'Coper'
    }
  },
  methods: {
    async getir () {
      this.error = null
      if (!this.date || !this.date2) {
        this.error = this.$t('Please-Select-Start-And-End-Date')
        this.items = []
        return
      }

      const start = this.toISO(this.date)
      const end   = this.toISO(this.date2)
      if (start > end) {
        this.error = this.$t('start-date-cannot-greater-than-end-date')
        this.items = []
        return
      }

      const url = this.endpointMap[this.selectedFilter]
      this.tableHeaders = this.headersMap[this.selectedFilter] || []

      const params = {
        StartDate: start + 'T00:00:00',
        EndDate:   end   + 'T23:59:59'
      }

      this.loading = true
      try {
        const resp = await this.$http.post(
          auth.API_URL + url,
          params,
          { headers: { Authorization: 'Bearer ' + auth.getAuthHeader() } }
        )

        // normalize response
        var body = (resp && resp.body != null) ? resp.body : (resp && resp.data != null ? resp.data : null)
        if (typeof body === 'string') { try { body = JSON.parse(body) } catch (e) {} }

        let items = []
        if (Array.isArray(body)) items = body
        else if (body && Array.isArray(body.data)) items = body.data
        else if (body && Array.isArray(body.Data)) items = body.Data
        else if (body && Array.isArray(body.result)) items = body.result
        else if (body && Array.isArray(body.Result)) items = body.Result

        // --- Sadece Coper için "List" içerenleri gizle ---
        if (this.selectedFilter === 'coper' && this.excludeListMethods) {
          items = items.filter(x => !this.isListMethod(x))
        }

        this.items = items
      } catch (e) {
        this.items = []
        this.error = (e && e.body && e.body.message) ? e.body.message : this.$t('Data-Retrieval-Error')
      } finally {
        this.loading = false
      }
    },

    filtreyiUygula () {
      this.dialogfiltre = false
     
       this.getir()
    },

    // "List" gösterme
    isListMethod (row) {
      var name = ''
      if (row) {
        if (row.MetotNameRaw) name = row.MetotNameRaw
        else if (row.Islem)   name = row.Islem
      }
      name = String(name || '').toLowerCase()
      if (name.indexOf('list') > -1) return true
      if (name.indexOf('liste') > -1) return true
      // sonu ...listcontrol / ...listpagingcontrol olanlar
      if (/list(control|pagingcontrol)?$/.test(name)) return true
      return false
    },

    // Date | "dd.MM.yyyy" | "yyyy-MM-dd" | ISO → "yyyy-MM-dd"
    toISO (val) {
      if (!val) return null
      if (val instanceof Date) {
        const y = val.getFullYear()
        const m = ('0' + (val.getMonth() + 1)).slice(-2)
        const d = ('0' + val.getDate()).slice(-2)
        return y + '-' + m + '-' + d
      }
      const s = String(val)
      if (s.indexOf('.') > -1) {
        const parts = s.split('.')
        if (parts.length === 3) {
          const dd = parts[0], mm = parts[1], yyyy = parts[2]
          return yyyy + '-' + ('0'+mm).slice(-2) + '-' + ('0'+dd).slice(-2)
        }
      }
      if (s.indexOf('T') > -1) return s.split('T')[0]
      return s
    },

    // Sayı formatı
    num (n) {
      try {
        return Number(n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      } catch (e) { return n }
    },

    // Tarih gösterimi 
    dt (iso) {
      if (!iso) return ''
      const s = String(iso)
      const d = s.indexOf('T') > -1 ? s.split('T')[0] : s
      const parts = d.split('-')
      if (parts.length === 3) return parts[2] + '.' + parts[1] + '.' + parts[0]
      return d
    }
  }
}
</script>
